import { gql } from '@apollo/client/core'
import { myKudosFragment } from '/@/common/kudos/fragments'

export const productFragment = gql`
  ${myKudosFragment}
  fragment ProductFields on Product {
    id
    thingType
    name
    description
    minPrice
    minPriceCent
    maxPrice
    maxPriceCent
    minWidthInches
    minHeightInches
    minDepthInches
    category {
      id
      key
      name
    }
    images {
      id
      url
      angle
    }
    skus {
      id
      vendorUrl
      cleanVendorUrl
      price
      priceCent
      imageId
      widthInches
      heightInches
      depthInches
      properties {
        id
        name
        value
      }
      sourceId
    }
    vendor {
      id
      name
      isVerified
    }
    vendorUrl
    cleanVendorUrl
    bookmarkInfo {
      id
    }
    addedByDesignerId
    addedBy {
      id
      firstName
      lastName
      imageUrl
      nickname
    }
    myKudos {
      ...MyKudosProps
    }
    allKudos {
      count
    }
    editable
    isVerified
    sourceId
  }
`
